import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { captureMessage } from '@sentry/angular';

@Injectable()
export class SnackService {
  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly translateService: TranslateService,
  ) {}

  snackThis(messageKey: string, messageParams: any = {}, err: unknown = null, config?: MatSnackBarConfig): MatSnackBarRef<SimpleSnackBar> {
    let configs = config;
    if (err) {
      configs = { ...(configs || {}), panelClass: 'error-snack-container' };
      console.error(err);
      captureMessage(`snackThis Error. [${err}]`, 'error');
    }

    const message = this.translateService.instant(messageKey, messageParams);
    return this.snackBar.open(message, this.translateService.instant('commons.btn.dismiss'), configs);
  }
}
